const humanizeDate = dateString => {
  const date = new Date(dateString)
  const formattedDate = Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(date)

  return formattedDate
}

export default humanizeDate
